<template>
  <el-button
    :disabled="disabled"
    :class="['report_button', `report_button--${type}`]"
    @click="handleClick"
  >
    <span class="report_button__text">{{ text }}</span>
  </el-button>
</template>

<script setup lang="ts">
type ReportButtonType = "default" | "success" | "primary";

const props = withDefaults(
  defineProps<{
    text?: string;
    type?: ReportButtonType;
    disabled?: boolean;
  }>(),
  {
    text: "按钮",
    type: "default",
    disabled: false,
  }
);

const emit = defineEmits<{
  click: [event: MouseEvent];
}>();

const handleClick = (event: MouseEvent) => {
  if (props.disabled) return;
  emit("click", event);
};
</script>

<style scoped lang="scss">
.report_button {
  width: 180px;
  height: 42px;
  font-size: 18px;
  font-weight: 400;
  color: #fff;
  border: none;
  border-radius: 21px;
  transition:
    transform 0.2s ease,
    filter 0.2s ease;

  &:hover {
    color: #fff;
    filter: brightness(0.97);
  }

  &:active {
    transform: translateY(1px);
  }

  &.is-disabled {
    opacity: 0.55;
  }
}

.report_button--default {
  background: linear-gradient(90deg, #4dc790 0%, #49dc90 100%);
}

.report_button--success {
  background: linear-gradient(90deg, #56baf7 0%, #45a7ef 100%);
}

.report_button--primary {
  background: linear-gradient(90deg, #8f73f2 0%, #7f66e8 100%);
}

.report_button__text {
  line-height: 1;
}
</style>
